import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

interface SourceStore {
    source?: string;
    setSource: (src: string) => void;
}

export const useSource = create<SourceStore>()(
    devtools(
        immer((set, _) => ({
            setSource: async (src: string) => {
                set({ source: src })
            }
        })),
    ),
);
